<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row">
                        <Loader v-if="isUsersFetchPending"
                                class="-sm m-2"/>
                        <template v-else>
                            Utilisateurs
                        </template>
                    </span>
                </span>
                <span>
                <a href="#" @click="handleCreateUser"
                   class="flex items-center px-4 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                    Créer un utilisateur
                    </a>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="users"
                    :columns="columns"
                    @editItem="handleEditUser"
                    @deleteItem="handleDeleteUser"
                    editable
                    deletable
                />

                <Pagination
                    v-if="lastPage > 1"
                    :current_page="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import Loader from "../../components/partials/loader";
import Pagination from "../../components/partials/pagination";
import Search from "../../components/partials/search";
import List from "../../components/partials/list";
import PageHeader from "../../components/partials/page-header"
import USER_ROLE from "../../enums/user-role"

export default {
    beforeMount() {
        this.$store.dispatch('users/getList', {
            search: this.isRoot ? {} : {corporation_id: this.authUser.corporation_id},
            includes: ['corporation']
        });
    },
    data() {
        return {
            sort_by: null,
            desc: false,
            search: null,
            delayer: null,
        }
    },
    computed: {
        locale() {
            return this.$store.state.config.locale;
        },
        isUsersFetchPending() {
            return this.$store.state.users.isFetchListPending;
        },
        authUser() {
            return this.$store.getters['auth/auth_user'];
        },
        users() {
            return this.$store.state.users.list;
        },
        isRoot() {
            return this.$store.getters['auth/isRoot']
        },
        lastPage() {
            return this.$store.state.users.pagination.last_page
        },
        currentPage() {
            return this.$store.state.users.pagination.current_page
        },
        columns() {
            return {
                id: {},
                name: {},
                email: {},
                role: {
                    sortable: false,
                    filter: {
                        readableEnum: USER_ROLE
                    }
                },
                'corporation.name': {
                    label: 'Corporation'
                }
            }
        }
    },
    methods: {
        handleChangePage(page) {
            this.$store.dispatch('users/getList', {
                page: page,
                sort_by: this.sort_by,
                desc: this.desc,
                search: this.isRoot ? {'title' : this.search } : {corporation_id: this.authUser.corporation_id, 'title' : this.search },
                includes: ['corporation']
            });
        },
        handleSortBy(type) {
            if(this.sort_by === type) {
                this.desc = !this.desc;
            }else {
                this.sort_by = type;
                this.desc = false;
            }

            this.handleChangePage(this.currentPage);
        },
        handleSearchChange(search) {
            this.search = search;
            this.handleChangePage();
        },
        handleDeleteUser(user) {
            this.$store.dispatch('users/setSingle', user);
            this.$store.dispatch('modals/open', 'user-delete');
        },
        handleEditUser(user) {
            this.$store.dispatch('users/setSingle', user);
            this.$store.dispatch('modals/open', 'user-save');
        },
        handleCreateUser() {
            this.$store.dispatch('users/resetSingle')
            this.$store.dispatch('modals/open', 'user-save');
        }
    },
    components: {
        Loader,
        Pagination,
        Search,
        List,
        PageHeader
    }
}
</script>
